import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";

let seenPromise = null;
const loadSeen = () => {
  seenPromise = seenPromise || api.get("/admin/seen").then(({ data }) => ({ seen: new Set(data.seen), unticked: new Set(data.unticked) }))
    .catch(() => { seenPromise = null; return { seen: new Set(), unticked: new Set() }; });
  return seenPromise;
};

export const SeenToggle = ({ email, testId, invited = false }) => {
  const key = (email || "").toLowerCase().trim();
  const [seen, setSeen] = useState(null);
  const [unticked, setUnticked] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let live = true;
    if (key) loadSeen().then((c) => { if (live) { setSeen(c.seen.has(key)); setUnticked(c.unticked.has(key)); } });
    const sync = (e) => { if (e.detail.email === key) { setSeen(e.detail.seen); setUnticked(!e.detail.seen); } };
    window.addEventListener("seen-changed", sync);
    return () => { live = false; window.removeEventListener("seen-changed", sync); };
  }, [key]);

  if (!key) return null;

  const toggle = async (e) => {
    const next = e.target.checked;
    setBusy(true);
    try {
      await api.put("/admin/seen", { email: key, seen: next });
      const c = await loadSeen();
      c.seen[next ? "add" : "delete"](key);
      c.unticked[next ? "delete" : "add"](key);
      window.dispatchEvent(new CustomEvent("seen-changed", { detail: { email: key, seen: next } }));
      toast.success(next ? "Marked as seen - they can now book follow-ups" : "Unticked - this patient can no longer book follow-ups");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
    <label className="inline-flex items-center gap-1.5 text-xs text-ink cursor-pointer whitespace-nowrap" title="Tick once the patient has been seen at the clinic - this lets them book £150 follow-ups from their account">
      <input type="checkbox" checked={!!seen} disabled={seen === null || busy} onChange={toggle}
        data-testid={testId || `seen-toggle-${key}`} className="accent-[#8C6643]" />
      Seen before
    </label>
    {seen === false && invited && !unticked && <div data-testid={`${testId || "seen"}-invite-note`} className="text-[11px] text-ink-muted">Can book via invite email</div>}
    </div>
  );
};
